import { render, staticRenderFns } from "./DetailListLayout.vue?vue&type=template&id=0a63d57a&scoped=true"
import script from "./DetailListLayout.vue?vue&type=script&lang=js"
export * from "./DetailListLayout.vue?vue&type=script&lang=js"
import style0 from "./DetailListLayout.vue?vue&type=style&index=0&id=0a63d57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63d57a",
  null
  
)

export default component.exports